<template>
    <div class="according_box">
        <div class="according_title" @click="openMenu(list.id)">
            {{ list.question }}
            <!-- <div :class="[ expand === list.id ? 'down_arrow' : 'up_arrow' ]"></div> -->
            <SvgHeaderSvg :type="expand === list.id ? 'up' : 'down'" />
        </div>
        <transition name="accordion" @before-enter="beforeEnter" @enter="enter" @leave="leave">
            <div class="according_body" v-if="expand === list.id">
                <p class="mb-0" v-html="list.answer"></p>
            </div>
        </transition>
    </div>
</template>


<script setup>
    const props = defineProps({
      list: Object
    });
    
    const expand = ref(null);
    
    
    const openMenu = (id) => {
        expand.value = expand.value === id ? null : id;
    };


    function beforeEnter(el) {
      el.style.height = "0";
    }
    function enter(el) {
      // Set height to the scrollHeight to smoothly transition to open state
      el.style.height = el.scrollHeight + "px";
    }
    function leave(el) {
      // Set height back to 0 when closing
      el.style.height = "0";
    }
</script>

<style scoped>
/* Transition Classes */
.accordion-enter-active, .accordion-leave-active {
  transition: height 0.3s ease-in-out;
  overflow: hidden;
}
.accordion{
    transition: 0.3s;
}

.accordion-enter, .accordion-leave-to{
  height: 0;
  transition: 0.3s ease-in-out;
}

.according_box {
    border: 1px solid #eaeaea;
    border-radius: 8px;
   
    margin-bottom: 16px;
}
.according_box .according_title {
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #353535;
    padding: 16px;
}

.according_box .according_body p {
    color: #606060;
    font-size: 16px;
    line-height: 1.5;
    padding: 0 16px 16px 16px;
}
.according_box .according_body p a{
    text-decoration: underline;
}
.according_box .down_arrow {
    height: 8px;
    width: 8px;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(-135deg);
    transition: 0.5s;
    margin: 10px;
}
.according_box .up_arrow {
    height: 8px;
    width: 8px;
    border-bottom: 1px solid #000;
    border-right: 1px solid #000;
    transform: rotate(45deg);
    transition: 0.5s;
    margin: 10px;
}


@media (max-width: 767px){
    .according_box .according_title {
        font-size: 16px;      
    }
}

</style>